import { NgModule } from '@angular/core';

import { FormChoiceSliderModule } from './form-choice-slider/form-choice-slider.component.module';
import { FormContactModule } from './form-contact/form-contact.module';
import { FormDatePickerModule } from './form-date-picker/form-date-picker.module';
import { FormDropdownModule } from './form-dropdown/form-dropdown.module';
import { FormFileModule } from './form-file/form-file.module';
import { FormInputModule } from './form-input/form-input.module';
import { FormRichTextModule } from './form-rich-text/form-rich-text.module';
import { FormSelectionListModule } from './form-selection-list/form-selection-list.module';
import { FormSliderModule } from './form-slider/form-slider.module';
import { FormToggleModule } from './form-toggle/form-toggle.module';
import { FormCheckboxModule } from './form-checkbox/form-checkbox.module';
import { FormAutocompleteModule } from './form-autocomplete/form-autocomplete.module';

@NgModule({
  imports: [
    FormChoiceSliderModule,
    FormContactModule,
    FormDatePickerModule,
    FormDropdownModule,
    FormFileModule,
    FormInputModule,
    FormRichTextModule,
    FormSelectionListModule,
    FormToggleModule,
    FormAutocompleteModule,
  ],
  exports: [
    FormChoiceSliderModule,
    FormContactModule,
    FormDatePickerModule,
    FormDropdownModule,
    FormFileModule,
    FormInputModule,
    FormRichTextModule,
    FormSelectionListModule,
    FormSliderModule,
    FormToggleModule,
    FormCheckboxModule,
    FormAutocompleteModule,
  ],
  declarations: [],
})
export class WaiFormControlsModule {}
